import React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as styles from './ArticlesPagination.module.scss';

interface ArticlesPaginationProps {
  entries: Array<{
    title: string;
    url: string;
    isActive: boolean;
  }>;
}

const ArticlesPagination = ({ entries }: ArticlesPaginationProps): React.ReactElement => {
  let previousPage = null;
  let nextPage = null;
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    if (entry.isActive) {
      if (i > 0) {
        previousPage = entries[i - 1];
      }
      if (i < entries.length - 1) {
        nextPage = entries[i + 1];
      }
    }
  }
  return (
    <div className={previousPage || nextPage ? styles.pagination : ' '}>
      {previousPage ? (
        <Link to={previousPage.url} className={styles.paginationLink + ' ' + styles.leftLink}>
          <FontAwesomeIcon icon="chevron-left" className={styles.iconLeft} />
          {previousPage.title}
        </Link>
      ) : (
        <div></div>
      )}
      {nextPage ? (
        <Link to={nextPage.url} className={styles.paginationLink + ' ' + styles.rightLink}>
          {nextPage.title}
          <FontAwesomeIcon icon="chevron-right" className={styles.iconRight} />
        </Link>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default ArticlesPagination;
